/**
 * Class defining market groups data descriptors.
 *
 * @class MarketGroupsDataDescriptor
 * @name descriptor
 * @memberof Mojito.Services.SportsContent.MarketGroups
 */
export default class MarketGroupsDataDescriptor {
    /**
     * Factory method for creating a market groups data descriptor.
     *
     * @param {Array<string>} groupIds - List of market group ids.
     * @param {string} instanceId - Subscriber instance id.
     *
     * @returns {{dataType: string, requests: Array<object>}} Market group data chunk descriptor.
     *
     * @function Mojito.Services.SportsContent.MarketGroups.descriptor.createGroupsDescriptor
     */
    static createGroupsDescriptor(groupIds, instanceId) {
        return {
            dataType: MarketGroupsDataDescriptor.DATA_TYPES.MARKET_GROUPS_CHUNK,
            requests: [{ itemIds: groupIds, clientId: instanceId }],
        };
    }
}

/**
 * System unique data descriptor types.
 *
 * @typedef DATA_TYPE
 * @property {string} MARKET_GROUPS - Market groups data descriptor type.
 * @property {string} MARKET_GROUPS_CHUNK - Market groups chunk data descriptor type.
 * @memberof Mojito.Services.SportsContent.MarketGroups.descriptor
 */
MarketGroupsDataDescriptor.DATA_TYPES = {
    MARKET_GROUPS_CHUNK: 'market-groups-chunk',
};
